import { type ApiHandlerContract, ApiService } from '@sparklayer-io/spark-dash-core/types/api';
import type { CompanyLookup } from '../../companies/types/api';
import type { SectionLookup, SectionRequest, SectionResponse } from '../types/api';

/**
 * A service contract to interact with a specific section via the SparkLayer API.
 */
export interface SectionApiContract {
  get(): Promise<SectionResponse>;
  update(payload: SectionRequest): Promise<SectionResponse>;
  delete(): Promise<void>;
}

/**
 * A service to interact with a specific section via the SparkLayer API.
 */
export class SectionApi extends ApiService implements SectionApiContract {
  constructor(
    api: ApiHandlerContract,
    private companyLookup: CompanyLookup,
    private sectionLookup: SectionLookup,
  ) {
    super(api);
  }

  get(): Promise<SectionResponse> {
    return this.api.proxy({
      method: 'GET',
      path: '/v2/companies/{lookupBy}/{identifier}/sections/{sectionLookupBy}/{sectionIdentifier}',
      params: {
        lookupBy: this.companyLookup.by,
        identifier: this.companyLookup.identifier,
        sectionLookupBy: this.sectionLookup.by,
        sectionIdentifier: this.sectionLookup.identifier,
      },
    });
  }

  update(payload: SectionRequest): Promise<SectionResponse> {
    return this.api.proxy({
      method: 'PUT',
      path: '/v2/companies/{lookupBy}/{identifier}/sections/{sectionLookupBy}/{sectionIdentifier}',
      payload,
      params: {
        lookupBy: this.companyLookup.by,
        identifier: this.companyLookup.identifier,
        sectionLookupBy: this.sectionLookup.by,
        sectionIdentifier: this.sectionLookup.identifier,
      },
    });
  }

  delete(): Promise<void> {
    return this.api.proxy({
      method: 'DELETE',
      path: '/v2/companies/{lookupBy}/{identifier}/sections/{sectionLookupBy}/{sectionIdentifier}',
      params: {
        lookupBy: this.companyLookup.by,
        identifier: this.companyLookup.identifier,
        sectionLookupBy: this.sectionLookup.by,
        sectionIdentifier: this.sectionLookup.identifier,
      },
    });
  }
}
